export default __webpack_public_path__ + "static/media/escaliers.2aa385ea.webp";